import { useState, useRef } from 'react';
import { DocumentRegisterForm } from '../../services/http/documents.api';
import PdfPreview, { PdfScrollMode } from '../../components/PdfPreview/PdfPreview';
import { usePdfViewerControl } from '../../hooks/usePdfViewerControl';
import styles from './docRegisterScreenPage.module.css';
import mainStyles from '../main.module.css';
import ScrollDrag from '../../components/PdfPreview/ScrollDrag';

/**
 * 文書登録機能に付随するPDFプレビューのプロップスインターフェース
 */
export interface DocRegisterPdfPreviewProps {
  /** 使用されるフォーム */
  form: DocumentRegisterForm;
}

/**
 * 文書登録に付随するPDFプレビューコンポーネント
 */
function DocRegisterPdfPreview({ form }: DocRegisterPdfPreviewProps) {
  const [initialZoom] = useState(1);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { zoomIn, zoomOut } = usePdfViewerControl(iframeRef);

  return (
    <div className={styles.mainFrameRightSectionCol2}>
      <div className={styles.mainFrameRightSectionCol2Header}>
        <img className={styles.button} src="/images/Icon-feather-minus.svg" alt="" onClick={zoomOut} />
        <div className={`${styles.pipeSeparator} ${mainStyles['ml-3']}`} />
        <img className={`${styles.button} ${mainStyles['ml-3']}`} src="/images/Icon-feather-plus.svg" alt="" onClick={zoomIn} />

        <select className={`${styles.button} ${mainStyles.select} ${mainStyles['ml-3']}`}>
          <option>PDFプレビュー</option>
        </select>

      </div>
      <div className={styles.mainFrameRightSectionCol2Body}>
        <ScrollDrag className={styles.pdfContainer}>
          <PdfPreview ref={iframeRef} pdfFile={form.documentFile} zoom={initialZoom} scrollMode={PdfScrollMode.WRAPPED} />
        </ScrollDrag>
      </div>
    </div>
  );
}

export default DocRegisterPdfPreview;
